import { Component, OnInit, Input } from '@angular/core';
import {ModalController} from '@ionic/angular';
import {UiUtils} from '../../util/ui-utils';
import {OrderItem} from "../../models/order-item";

@Component({
  selector: 'app-weight-select-modal',
  templateUrl: './weight-select-modal.component.html',
  styleUrls: ['./weight-select-modal.component.scss'],
})
export class WeightSelectModalComponent implements OnInit {

  @Input() orderItem: OrderItem;

  constructor(private modalController: ModalController,
              private uiUtils: UiUtils) {
  }

  ngOnInit() {
    this.fixStartingValue();
    this.modalController.getTop().then((ionModal: HTMLIonModalElement) => ionModal.cssClass = 'weight-select-modal');
  }

  dismissSelfWithData() {
    // tslint:disable-next-line:max-line-length
    if (this.orderItem.quantity > this.orderItem.maxWeight) return this.uiUtils.showConfirmAlert('Peso invalido', 'O peso excede a quantidade maxima permitida', 'Aceitar');
    this.modalController.dismiss({ 'quantity': +this.orderItem.quantity.toFixed(2) });
  }

  fixStartingValue() {
    this.orderItem.quantity = Math.min(this.orderItem.quantity, this.orderItem.maxWeight);
  }

}
